import React from 'react';
import PropTypes from 'prop-types';

const AssessmentEvidenceSwitch = (props) => (
  <nav className='switch-nav u-push--top'>
    <a onClick={(e) => props.handleTypeClick('ibsl', e)} className={props.switchType === 'ibsl' ? 'is-active' : ''}>
      <strong className='switch-nav__title'>
        <span className='long'>IBSL assessment</span>
        <span className='short'>IBSL</span>
      </strong>
    </a>
    <a onClick={(e) => props.handleTypeClick('signature', e)} className={props.switchType === 'signature' ? 'is-active' : ''}>
      <strong className='switch-nav__title'>
        <span className='long'>Signature NVQ evidence</span>
        <span className='short'>Signature</span>
      </strong>
    </a>
  </nav>
);

AssessmentEvidenceSwitch.propTypes = {
  switchType: PropTypes.string,
  handleTypeClick: PropTypes.func
};

export default AssessmentEvidenceSwitch;



// WEBPACK FOOTER //
// ./src/components/AssessmentEvidenceSwitch/index.js